//############################################################################################
//# axboot.parent
//############################################################################################

axboot.parent = function () {
    var action = function (action, data) {
        if (ax5.util.isNothing(this.getFrame())) {
            this.getFrame().ACTIONS.dispatch(this.getFrame().ACTIONS[action], data);
        }
    }

    var getFrame = function () {
        var parentFrame;

        if (window.parent != window) {
            parentFrame = window.parent;
        }

        return parentFrame;
    }

    return {
        'action'   : action,
        'getFrame' : getFrame
    }
}();
